/**
 * Flatten a raw product data object into string key-value pairs.
 */
export function flattenRawData(raw: Record<string, unknown>): Record<string, string> {
  const result: Record<string, string> = {};
  for (const [key, value] of Object.entries(raw)) {
    result[key] = value != null ? String(value) : '';
  }
  return result;
}

/**
 * Decode HTML entities that may appear in XML feed product URLs.
 */
export function sanitizeImageUrl(url: string): string {
  return url
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .trim();
}

/**
 * Strip HTML tags from a string.
 */
export function stripHtmlTags(html: string): string {
  return html.replace(/<[^>]*>/g, '');
}

/**
 * Truncate text to maxChars, handling HTML content gracefully.
 */
export function truncateText(text: string, maxChars: number, isHtml = false): string {
  if (!maxChars || maxChars <= 0) return text;
  if (isHtml) {
    const plain = stripHtmlTags(text);
    if (plain.length <= maxChars) return text;
    return plain.slice(0, maxChars) + '\u2026';
  }
  if (text.length <= maxChars) return text;
  return text.slice(0, maxChars) + '\u2026';
}

/**
 * Replace {{field}} tokens with resolved values from sample data.
 */
export function resolveTokens(
  str: string,
  sampleData?: Record<string, string>,
): string {
  if (!sampleData) return str;
  return str.replace(/\{\{([^}]+)\}\}/g, (_, key) => sampleData[key] ?? `{{${key}}}`);
}
